import {
  Button,
  CircularProgress,
  Container,
  Grid,
  ThemeProvider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ITheme, theme } from "../constants/theme";
import { clearPackages, getPackages } from "../redux/actions/packages";
import { useDispatch, useSelector } from "react-redux";

import arrowRight from "../assets/icons/arrowRight.svg";
import printIconDisabled from "../assets/icons/printIconDisabled.svg";
import printIconWhite from "../assets/icons/printIconWhite.svg";
import { useEffect } from "react";
import { roleName } from "../utils/roles";

export const OrderDetailsPackageInfoSection = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const packagesInfo = useSelector((state: any) => state.packages.data);
  const { data, disabled } = props;
  useEffect(() => {
    if (data.ShopPortalStatus !== "Pending") {
      dispatch(getPackages(data.Id));
    }
    return () => {
      dispatch(clearPackages());
    };
  }, []); // eslint-disable-line
  const GetContainerBackgroundColor = () => {
    if (data.ShopPortalStatus !== "Pending") {
      return theme.palette.background.default;
    } else {
      return props.enterPackageNumber
        ? theme.palette.secondary.main
        : theme.palette.background.default;
    }
  };
  const GetNumberOfPackages = () => {
    if (data.ShopPortalStatus !== "Pending") {
      return (
        <Typography variant="body1" component="span">
          {packagesInfo.length}
        </Typography>
      );
    } else {
      return props.enterPackageNumber ? (
        <Typography variant="body1" component="span">
          Enter number of packages to print out labels
        </Typography>
      ) : (
        <Typography variant="body1" component="span">
          {props.numberOfPackages}
        </Typography>
      );
    }
  };
  return (
    <ThemeProvider theme={theme}>
      <Container
        style={{
          backgroundColor: GetContainerBackgroundColor(),
        }}
        className={classes.packageInformationContainer}
      >
        <Grid container>
          <Grid container direction="row" className={classes.infoTitle}>
            <Grid item xs={8}>
              <Typography variant="h6" component="span" color="textPrimary">
                Accept Order and Confirm Number of Packages
              </Typography>
            </Grid>
            <Grid item container justifyContent="flex-end" xs={4}>
              {roleName() !== "Admin" &&
                (data.ShopPortalStatus === "Queued" ||
                data.ShopPortalStatus === "Archived" ||
                data.ShopPortalStatus === "Failed" ? (
                  !data.Cancelled &&
                  !data.Rejected &&
                  data.ShopPortalStatus !== "Archived" &&
                  data.ShopPortalStatus !== "Failed" ? (
                    <Button
                      className={classes.printLabelsButton}
                      style={{
                        backgroundColor: theme.palette.primary.main,
                      }}
                    >
                      {props.deliveryAcceptLoading ? (
                        <CircularProgress
                          size="18px"
                          style={{ color: "white" }}
                          className={classes.buttonIcon}
                        />
                      ) : (
                        <img
                          src={printIconWhite}
                          className={classes.buttonIcon}
                          alt="print icon white"
                        />
                      )}

                      <Typography
                        variant="button"
                        component="span"
                        style={{
                          color: theme.palette.text.hint,
                        }}
                        onClick={props.onPrintLabelsAgainClicked}
                      >
                        {"Print labels again"}
                      </Typography>
                    </Button>
                  ) : (
                    <></>
                  )
                ) : (
                  <Button
                    disabled={props.enterPackageNumber}
                    className={
                      !props.enterPackageNumber
                        ? classes.printLabelsButton
                        : classes.printLabelsButtonDisabled
                    }
                  >
                    {props.deliveryAcceptLoading ? (
                      <CircularProgress
                        size="18px"
                        style={{ color: "white" }}
                        className={classes.buttonIcon}
                      />
                    ) : (
                      <img
                        src={
                          props.enterPackageNumber
                            ? printIconDisabled
                            : printIconWhite
                        }
                        className={classes.buttonIcon}
                        alt="print icon"
                      />
                    )}

                    <Typography
                      variant="button"
                      component="span"
                      style={{
                        color: props.enterPackageNumber
                          ? theme.palette.text.disabled
                          : theme.palette.text.hint,
                      }}
                      onClick={props.onPrintLabelsClicked}
                    >
                      {props.enterPackageNumber
                        ? "Accept Order & Print Labels"
                        : "Accept Order & Print " +
                          props.numberOfPackages +
                          " Labels"}
                    </Typography>
                  </Button>
                ))}
            </Grid>
          </Grid>
          <Grid
            container
            className={
              disabled ||
              data.ShopPortalStatus === "Queued" ||
              data.ShopPortalStatus === "Archived" ||
              data.ShopPortalStatus === "Failed"
                ? classes.infoTextContainer
                : classes.infoTextContainerClickable
            }
            style={{ borderWidth: packagesInfo.length > 0 ? 1 : 0 }}
            onClick={
              disabled ||
              data.ShopPortalStatus === "Queued" ||
              data.ShopPortalStatus === "Archived" ||
              data.ShopPortalStatus === "Failed"
                ? null
                : props.packageSelectionClicked
            }
          >
            <Grid item xs={3}>
              <Typography
                variant="caption"
                component="span"
                color="textSecondary"
                display="inline"
              >
                NUMBER OF PACKAGES
              </Typography>
            </Grid>
            <Grid item xs={7} className={classes.colOffset}>
              {GetNumberOfPackages()}
            </Grid>
            <Grid item container justifyContent="flex-end" xs={2}>
              {data.ShopPortalStatus === "Queued" ||
              data.ShopPortalStatus === "Archived" ||
              data.ShopPortalStatus === "Failed" ? (
                <></>
              ) : (
                <div
                  className={classes.arrowContainer}
                  data-arrow="arrowContainer"
                >
                  <img src={arrowRight} alt="arrow" />
                </div>
              )}
            </Grid>
          </Grid>
          {data.ShopPortalStatus !== "Pending" ? (
            packagesInfo.map((item: any, index: any) => (
              <Grid
                container
                className={`${classes.infoTextContainer} ${
                  index === packagesInfo.length - 1
                    ? classes.noBorderBottom
                    : ""
                }`}
              >
                <Grid item xs={3}>
                  <Typography
                    display="inline"
                    variant="caption"
                    component="span"
                    color="textSecondary"
                  >
                    {"PACKAGE NR." + (index + 1)}
                  </Typography>
                </Grid>
                <Grid item xs={7} className={classes.colOffset}>
                  <Typography
                    variant="body1"
                    component="span"
                    color="textPrimary"
                  >
                    {item.PackageNo}
                  </Typography>
                </Grid>
              </Grid>
            ))
          ) : (
            <></>
          )}
        </Grid>
      </Container>
    </ThemeProvider>
  );
};
const useStyles = makeStyles((theme: ITheme) => ({
  packageInformationContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "18px 24px 0",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
    marginTop: "24px",
  },
  printLabelsButton: {
    backgroundColor: theme.palette.primary.main,
    color: "rgba(255, 255, 255, 1)",
    textTransform: "none",
    paddingRight: 16,
    paddingLeft: 12,
    "&:hover": {
      backgroundColor: theme.palette.primary[92],
    },
    "&:active": {
      backgroundColor: theme.palette.primary[76],
    },
  },
  printLabelsButtonDisabled: {
    backgroundColor: theme.palette.action.disabledBackground,
    color: "rgba(255, 255, 255, 1)",
    textTransform: "none",
    paddingRight: 16,
    paddingLeft: 12,
  },
  infoTitle: {
    marginBottom: 20,
  },
  infoTextContainer: {
    alignItems: "center",
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  infoTextContainerClickable: {
    alignItems: "center",
    paddingTop: 5,
    paddingBottom: 5,
    "&:hover": {
      cursor: "pointer",
    },
    "&:hover [data-arrow=arrowContainer]": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
    "&:active [data-arrow=arrowContainer]": {
      backgroundColor: "rgba(0, 0, 0, 0.16)",
    },
  },
  noBorderBottom: {
    borderBottom: 0,
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
  arrowContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 40,
    height: 40,
    borderRadius: 20,
  },
  colOffset: {
    marginLeft: -17.5,
    marginRight: 17.5,
  },
}));
